import GuestService from '@/services/GuestService'
import FacebookService from '@/services/FacebookService'
import UserService from '@/services/UserService'
import { opponentIds } from '@/data/opponents'
import fromEntries from 'object.fromentries'

export default {
  namespaced: true,
  state: {
    userProfile: null
  },
  mutations: {
    setUserProfile (state, value) {
      state.userProfile = value
    }
  },
  getters: {
    highScoresByOpponent (state) {
      if (!state.userProfile) return []
      let highScoresByOpponent = fromEntries(opponentIds.map(id => [id, { score: 0, roundIndex: null }]))
      highScoresByOpponent = state.userProfile.rounds.reduce((acc, round, i) => {
        if (!acc[round.opponentId]) return acc
        if (round.score < acc[round.opponentId].score) return acc
        acc[round.opponentId].score = round.score
        acc[round.opponentId].roundIndex = i
        return acc
      }, highScoresByOpponent)
      highScoresByOpponent = fromEntries(opponentIds.map(id => [id, state.userProfile.rounds[highScoresByOpponent[id].roundIndex] || null]))
      return highScoresByOpponent
    },
    opponentUnlockedStates (_, getters) {
      const opponentUnlockedStates = {}
      for (const [i, id] of opponentIds.entries()) {
        if (i === 0) { opponentUnlockedStates[id] = true; continue }
        const highestScoreAgainstOpponentToBeat = getters.highScoresByOpponent[opponentIds[i - 1]]
        opponentUnlockedStates[id] = !!highestScoreAgainstOpponentToBeat && highestScoreAgainstOpponentToBeat.userWon
      }
      return opponentUnlockedStates
    },
    userHasBeatenAllOpponents (_, getters) {
      return Object.values(getters.highScoresByOpponent).every(round => round && round.userWon)
    }
  },
  actions: {
    async login ({ commit }, provider) {
      let fetchedUserProfile = null
      let userProfile = null
      if (provider === 'facebook') {
        fetchedUserProfile = await FacebookService.fetchUserProfile()
        userProfile = await UserService.login(fetchedUserProfile)
        localStorage.setItem('id', userProfile._id)
      }
      if (provider === 'guest') {
        fetchedUserProfile = GuestService.fetchUserProfile()
        userProfile = fetchedUserProfile
      }
      commit('setUserProfile', userProfile)
      return userProfile
    },
    async getLoginStatus ({ dispatch }) {
      const id = localStorage.getItem('id')
      if (!id) return false
      const userProfile = await dispatch('getUserProfile', id)
      if (userProfile) return true
      dispatch('logout')
      return false
    },
    async getUserProfile ({ commit }, id) {
      const userProfile = await UserService.getUserProfile(id)
      commit('setUserProfile', userProfile)
      return userProfile
    },
    logout ({ commit }) {
      localStorage.removeItem('id')
      commit('setUserProfile', null)
    }
  }
}
